function _localeDynamicImportRuntime(module, locale) {
  try {
    return import(`./modules/${module}/${locale}.json`)
  } catch (_) {
    return new Promise(function (resolve, reject) {
      queueMicrotask(
        reject.bind(
          null,
          new Error(
            'Unknown variable dynamic import: ' + module + ' in ' + locale
          )
        )
      )
    })
  }
}

async function importLocale(module, locale) {
  const [lang] = locale.replace('-', '_').split('_')
  const mapping = {
    en: 'en_US',
    ar: 'ar_SA',
  }
  const targetLocale = mapping[lang] || 'ar_SA'

  const data = await _localeDynamicImportRuntime(module, targetLocale)

  return data.default
}

export { importLocale }
